import { render } from "./ParticipantsGrid.vue?vue&type=template&id=54096d31&scoped=true"
import script from "./ParticipantsGrid.vue?vue&type=script&lang=js"
export * from "./ParticipantsGrid.vue?vue&type=script&lang=js"

import "./ParticipantsGrid.vue?vue&type=style&index=0&id=54096d31&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-54096d31"

export default script